import { Link } from "react-router-dom";
import Icon from "./Icon";
import { formatNumber } from "../utils/format";

const GuildCard = ({ guild }) => (
  <article className="panel flex h-full flex-col gap-5">
    <header className="flex flex-wrap items-start gap-4">
      <span
        className="grid h-14 w-14 place-content-center rounded-2xl border border-brand-ink/50 bg-brand-night/80 text-base font-semibold text-slate-100"
        style={{ color: guild.accentColor }}
      >
        {guild.logo}
      </span>
      <div className="flex-1 space-y-1">
        <p className="text-[11px] uppercase tracking-[0.3em] text-brand-steel">{guild.category}</p>
        <h3 className="text-2xl text-slate-100">{guild.name}</h3>
        <p className="text-sm text-slate-400">{guild.tagline}</p>
      </div>
      <div className="text-xs uppercase tracking-[0.3em] text-brand-steel">
        <p>{guild.regionFocus}</p>
        <p>Founded {guild.founded}</p>
      </div>
    </header>

    <p className="text-sm text-slate-300">{guild.description}</p>

    <div className="flex flex-wrap gap-2 text-xs text-brand-steel">
      <span className="chip chip-soft">{guild.regionFocus}</span>
      <span className="chip chip-soft">{guild.platforms.length} platforms</span>
      {guild.tags.slice(0, 2).map((tag) => (
        <span key={tag} className="chip chip-soft">
          {tag}
        </span>
      ))}
    </div>

    <dl className="grid gap-3 rounded-2xl border border-brand-ink/40 bg-brand-midnight/80 p-4 text-sm text-slate-200 sm:grid-cols-3">
      <div>
        <dt className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-brand-steel">
          <Icon name="shield" className="h-4 w-4 text-brand-sun" />
          Members
        </dt>
        <dd className="text-lg font-semibold text-brand-highlight">{formatNumber(guild.memberCount)}</dd>
      </div>
      <div>
        <dt className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-brand-steel">
          <Icon name="layers" className="h-4 w-4 text-brand-mint" />
          Communities
        </dt>
        <dd className="text-lg font-semibold text-brand-highlight">{guild.communitiesCount}</dd>
      </div>
      <div>
        <dt className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-brand-steel">
          <Icon name="map" className="h-4 w-4 text-brand-coral" />
          Platforms
        </dt>
        <dd className="text-lg font-semibold text-brand-highlight">{guild.platforms.length}</dd>
      </div>
    </dl>

    <div className="flex flex-wrap gap-2">
      {guild.tags.slice(0, 5).map((tag) => (
        <span key={tag} className="chip">
          {tag}
        </span>
      ))}
    </div>

    <div className="mt-auto grid gap-3 text-sm sm:grid-cols-2">
      <Link to={`/guilds/${guild.id}`} className="btn-primary justify-center">
        View guild hub
      </Link>
      <Link to={`/guilds/${guild.id}/map`} className="btn-secondary justify-center">
        Guild mini-map
      </Link>
    </div>
  </article>
);

export default GuildCard;
